import { render, staticRenderFns } from "./PartnerSites.vue?vue&type=template&id=a0e5d2d4&"
import script from "./PartnerSites.vue?vue&type=script&lang=js&"
export * from "./PartnerSites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports